export const getInnerPadding = (isPadding = false) => isPadding ? {} : { padding: 'p-0' };
//# sourceMappingURL=getInnerPadding.js.map